"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=require("styled-components"),t=require("./creditFigmaToken-d1c28f0d.js"),f=o.css`
  @font-face {
    font-family: 'FordF1-Bold';
    font-weight: 700;
    src: url('https://www.ford.com/finance/content/dam/ucl/fomo/fonts/FordF-1-Bold.otf') format('opentype');
    font-display: block;
  }
  @font-face {
    font-family: 'FordF1-Semibold';
    font-weight: 600;
    src: url('https://www.ford.com/finance/content/dam/ucl/fomo/fonts/FordF-1-Semibold.otf') format('opentype');
    font-display: block;
  }
  @font-face {
    font-family: 'FordF1-Regular';
    font-weight: 400;
    src: url('https://www.ford.com/finance/content/dam/ucl/fomo/fonts/FordF-1-Regular.otf') format('opentype');
    font-display: block;
  }
  @font-face {
    font-family: 'FordF1-Medium';
    font-weight: 500;
    src: url('https://www.ford.com/finance/content/dam/ucl/fomo/fonts/FordF-1-Medium.otf') format('opentype');
    font-display: block;
  }
  @font-face {
    font-family: 'FordF1-Light';
    font-weight: 300;
    src: url('https://www.ford.com/finance/content/dam/ucl/fomo/fonts/FordF-1-Light.otf') format('opentype');
    font-display: block;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    ${o.css(t.fcds.semanticMode1.body1.regular.value).join(`
`)}
  }
`,r=o.css`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap');
  @font-face {
    font-family: 'Ford F-1';
    font-weight: 400;
    src: url('https://cxc-assets.fordpro.com/fonts/ford/FordF-1-Regular.woff2') format('woff2');
    font-display: block;
  }
  @font-face {
    font-family: 'Ford F-1';
    font-weight: 500;
    src: url('https://cxc-assets.fordpro.com/fonts/ford/FordF-1-Medium.woff2') format('woff2');
    font-display: block;
  }
  @font-face {
    font-family: 'Ford F-1';
    font-weight: 600;
    src: url('https://cxc-assets.fordpro.com/fonts/ford/FordF-1-Semibold.woff2') format('woff2');
    font-display: block;
  }
  @font-face {
    font-family: 'FordMotion';
    font-weight: 400;
    src: url('https://cxc-assets.fordpro.com/fonts/ford/FordMotion-Regular.woff2') format('woff2'),
      url('https://cxc-assets.fordpro.com/fonts/ford/FordMotion-Regular.woff') format('woff');
    font-display: block;
  }
  @font-face {
    font-family: 'FordMotion';
    font-weight: 500;
    src: url('https://cxc-assets.fordpro.com/fonts/ford/FordMotion-Medium.woff2') format('woff2'),
      url('https://cxc-assets.fordpro.com/fonts/ford/FordMotion-Medium.woff') format('woff');
    font-display: block;
  }
  @font-face {
    font-family: 'FordMotion';
    font-weight: 600;
    src: url('https://cxc-assets.fordpro.com/fonts/ford/FordMotion-SemiBold.woff2') format('woff2'),
      url('https://cxc-assets.fordpro.com/fonts/ford/FordMotion-SemiBold.woff') format('woff');
    font-display: block;
  }
`;exports.FordCreditGlobalStyles=f;exports.FordProGlobalStyles=r;
